/*
 * @Description:
 * @Author: 姜暖阳
 * @Date: 2021-10-21 15:15:57
 * @LastEditTime: 2023-10-08 11:05:46
 * @LastEditors: 赵大壮
 * @Reference:
 */
import config from '../nyConfig'
const ApiWikipedia = {

    "添加百科标签": new config({url: '/wikipedia/addLable', showSuccessMessage: true, useToken: true }),
    "编辑百科标签": new config({url: '/wikipedia/editLable', showSuccessMessage: true, useToken: true }),
    "删除百科标签": new config({url: '/wikipedia/delLabel', showSuccessMessage: true, useToken: true }),
    "百科标签分页": new config({url: '/wikipedia/pageLabel', showSuccessMessage: false, useToken: true }),
    "百科标签列表": new config({url: '/wikipedia/listLabel', showSuccessMessage: false, useToken: true }),

    "添加百科分类": new config({url: '/wikipedia/addType', showSuccessMessage: true, useToken: true }),
    "编辑百科分类": new config({url: '/wikipedia/editType', showSuccessMessage: true, useToken: true }),
    "删除百科分类": new config({url: '/wikipedia/delType', showSuccessMessage: true, useToken: true }),
    "百科分类列表": new config({url: '/wikipedia/pageType', showSuccessMessage: false, useToken: true }),
    "百科分类所有": new config({url: '/wikipedia/listType', showSuccessMessage: false, useToken: true }),

    "添加百科": new config({url: '/wikipedia/addInfo', showSuccessMessage: true, useToken: true }),
    "编辑百科": new config({url: '/wikipedia/editInfo', showSuccessMessage: true, useToken: true }),
    "删除百科": new config({url: '/wikipedia/delInfo', showSuccessMessage: true, useToken: true }),
    "百科分页列表": new config({url: '/wikipedia/pageInfo', showSuccessMessage: false, useToken: true }),
    "百科列表": new config({url: '/wikipedia/listInfo', showSuccessMessage: false, useToken: true }),
    "百科详情": new config({url: '/wikipedia/getInfo', showSuccessMessage: false, useToken: true }),
}

export default ApiWikipedia
